module.exports = __webpack_public_path__ + "media/images/front/brands/signature/signature_bg-d76fe74da46e953cac2902dd2e0102df.jpg";